import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./store-actions";
import accountApi from "apis/account";

type InitialState = {
  authUser: any | null;
  isSideNavigation: boolean;
  isLoadingModal: boolean;
  userPoints: number | null;
};

export const initialState: InitialState = {
  authUser: null,
  isSideNavigation: false,
  isLoadingModal: false,
  userPoints: null,
};

export const slice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setAuthUser: (state, { payload }) => {
      state.authUser = payload;
    },
    setUserPoints: (state, { payload }) => {
      state.userPoints = payload;
    },
    toggleSideNavigation: (state, { payload }) => {
      state.isSideNavigation =
        payload !== undefined ? !!payload : !state.isSideNavigation;
    },
    toggleLoadingModalAction: (state, { payload }) => {
      state.isLoadingModal =
        payload !== undefined ? !!payload : !state.isLoadingModal;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(logout, () => ({ ...initialState }))
      .addMatcher(
        accountApi.endpoints.loginAccount.matchFulfilled,
        (state, { payload }) => {
          state.authUser = payload.data;
        }
      ),
});

export const { toggleSideNavigation, toggleLoadingModalAction, setUserPoints } =
  slice.actions;

export default slice;

export function getStorageState({ authUser }: InitialState) {
  return { authUser };
}
